<template>
  <div v-if="isLoaded">
<!--    <div v-if="entity.enabled">-->
      <page-title v-if="pageTitle && !titleInCard">
        <button-group v-if="buttons.head"
                      :buttons="buttons.head.right"
                      :class="getFlexboxClass('right')"
                      class="float-right"
        />
        {{ pageTitle }}
      </page-title>
      <!-- <b-card no-body bg-variant="primary" class="card-show"> -->
      <b-card no-body class="card-show">
        <b-card-body>
        <h3 v-if="pageTitle && titleInCard">{{ pageTitle }}</h3>
        <b-tabs>
          <b-tab v-for="obj in content" :key="obj.id">
            <template slot="title">
              {{ getTabTitle(obj.type, obj.label) }}

              <b-badge v-if="obj.type === 'list'">
                {{ getTabNbRows(obj.entityName) }}
              </b-badge>
            </template>
            <tab-main-show v-if="obj.type === 'main'" :rows="obj.rows" />
            <tab-list-show v-else-if="obj.type === 'list'" :entity-name="obj.entityName" :parent-api-details="getApiObjectDetails()" :overrides="obj.overrides" />
            <component v-else-if="obj.type === 'custom'" :is="obj.component" :entity="entity" />
          </b-tab>
        </b-tabs>
        </b-card-body>

        <b-card-footer>
          <button-group v-for="(button, position) in buttons.bottom"
                        :key="button.id"
                        v-if="button.length"
                        :buttons="buttons.bottom[position]"
                        :positioning-clues="{
                          overall: buttons.bottom,
                          position: position
                        }"
          />
        </b-card-footer>
      </b-card>
<!--    </div>-->
  </div>
</template>

<script>
import { flexbox } from '@/utils/style'
import { createShowTabs, getShowButtons } from '@/utils/show'
import AbstractApi from '@/api/abstractApi'
import pageTitle from '@/components/backoffice/pageTitle'
import tabMainShow from '@/components/backoffice/show/tabs/main'
import tabListShow from '@/components/backoffice/show/tabs/list'
import buttonGroup from '@/components/backoffice/button/group'
import bTabs from 'bootstrap-vue/es/components/tabs/tabs'
import bTab from 'bootstrap-vue/es/components/tabs/tab'
import bBadge from 'bootstrap-vue/es/components/badge/badge'
import surveyReply from '@/components/backoffice/show/customShowComponent/surveyReply'
import bookingHrsDetails from '@/components/backoffice/show/customShowComponent/bookingHrsDetails'
import travelPolicy from '@/components/backoffice/show/customShowComponent/travelPolicy'
import backOfficeAccessMixin from '../../../conf/backOfficeAccessMixin'
import fieldsWhiteMark from '@/components/backoffice/show/customShowComponent/fieldsWhiteMark'
import hotelMap from '@/components/backoffice/show/customShowComponent/hotelMap'
export default {
  components: {
    pageTitle,
    bTabs,
    bTab,
    bBadge,
    tabMainShow,
    tabListShow,
    buttonGroup,
    surveyReply,
    bookingHrsDetails,
    travelPolicy,
    fieldsWhiteMark,
    hotelMap
  },

  mixins: [backOfficeAccessMixin],

  props: {
    entityName: {
      type: String,
      required: true
    },
    id: {
      type: [Number, String],
      required: true
    },
    titleInCard: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      pageTitle: '',
      apiObject: {},
      translationPrefix: '',
      entity: null,
      content: [],
      buttons: {},
      isLoaded: false,
    }
  },

  async created () {
    this.apiObject = new AbstractApi(this.entityName, this.id)
    this.translationPrefix = this.apiObject.getShowTranslationPrefix()
    await this.apiObject.loadEntity(true)
      .then(response => {
        this.entity = this.apiObject.parseApiObject(response)
        this.isLoaded = true
      }).then(this.init)
  },

  mounted () {

  },

  computed: {
    displayMapOrRequestsContingent () {
      return this.displayMapContingent
    },

    displayMapContingent () {
      if (this.entity) {
        return !!(this.entity.geo_lat && this.entity.geo_lng)
      } else return false
    }
  },

  methods: {
    init () {
      this.setPageTitle()
      this.setContent()
      this.setButtons()
    },

    setPageTitle () {
      let titleAuto = this.translationPrefix + '.page_title'
      if (this.apiObject.getTitleField()) {
        let titleField = this.apiObject.getTitleField()
        this.pageTitle = this.$i18n.t(this.apiObject.getEntityName() + '.show.page_title')
        if (this.entity[titleField]) this.pageTitle += ` ${this.entity[titleField]}`
      } else if (this.$i18n.te(titleAuto)) {
        this.pageTitle = this.$i18n.t(titleAuto) + ' ' + this.entity.name
      } else {
        this.pageTitle = this.$i18n.t(this.apiObject.getEntityName() + '.show.page_title') + ' ' + this.entity.name
      }
    },

    setContent () {
      this.content = createShowTabs(
        this.translationPrefix,
        this.apiObject.getEntityName(),
        this.apiObject.getConf('show', 'tabs'),
        this.apiObject.getConf('fields'),
        this.entity,
        this.apiObject.getConf('shrinkRelatedEntities')
      )
    },

    setButtons () {
      this.buttons = getShowButtons(
        this.apiObject.getEntityName(),
        this.apiObject.getConf('show', 'buttons'),
        this.apiObject.getId(),
        this.displayOnlyShowButton,
        this.hotelRestrictionButton,
        this.entity
      )
    },

    getApiObjectDetails () {
      return {
        entityName: this.apiObject.getEntityName(),
        id: this.apiObject.getId()
      }
    },

    getTabNbRows (entityName) {
      // Un contexte est devant, on prend le second argument
      if (entityName.split('_').length > 1) {
        entityName = entityName.split('_')[1]
      }
      return this.entity[entityName + '_count']
    },

    getTabTitle (type, label) {
      if (type === 'list') {
        if (this.$i18n.te(label + '_s')) return this.$i18n.tc(label + '_s', 2)
        else return this.$i18n.tc(label, 2)
      } else {
        return this.$i18n.t(label)
      }
    },

    getFlexboxClass (position) {
      return flexbox.position.justifyContent(position)
    }
  }
}
</script>

<style>
.map{
  position: absolute;
  overflow :hidden
}
</style>
